import React, { type ReactElement, type ReactNode } from 'react';

import classnames from 'classnames';

import styles from './Content.module.scss';

type ContentProps = {
    children: ReactNode;
    className?: string;
};

const Content = ({ children, className }: ContentProps): ReactElement => {
    return <div className={classnames(styles.container, className)}>{children}</div>;
};

export default Content;
